export default {
  'component.tagSelect.expand': 'Кушодан',
  'component.tagSelect.collapse': 'Печонидан',
  'component.tagSelect.all': 'Ҳама',
  'component.global.copy': 'Нусха гирифтан',
  'component.global.save': 'Захира',
  'component.avatarDropdown.personalProfile': 'Профили шахсӣ',
  'component.avatarDropdown.personalSettings': 'Танзимоти шахсӣ',
  'component.avatarDropdown.logout': 'Баромадан',
  'component.contextSwitcher.select': 'Мавқеъро интихоб кунед',
  'component.contextSwitcher.fallback': 'Мавқеъ',
  'component.contextSwitcher.reset': 'Бозгашт ба профили асосӣ',
  'component.contextSwitcher.switchFailed': 'Гузариши контекст ноком шуд',
  'component.contextSwitcher.org.methodologicalDepartment': 'Шуъбаи методологӣ',
  'component.contextSwitcher.org.developmentDepartment': 'Шуъбаи барномасозӣ',
  'component.positionGate.title': 'Мавқеъро интихоб кунед',
  'component.positionGate.description':
    'Кор аз номи як мавқеъ меравад: ҳар яке иҷозот ва интерфейси худро дорад. Мавқеъро дар панели болоӣ иваз кардан мумкин аст.',
  'component.themeSwitch.toDark': 'Ҳолати шабона',
  'component.themeSwitch.toLight': 'Ҳолати рӯзона',
  'component.workArea.drag': 'Ҷойивазкунӣ',
  'component.workArea.collapse': 'Печонидан',
  'component.workArea.expand': 'Кушодан',
  'component.workArea.empty': 'Ҳама фреймҳо печонида шудаанд',
};
